/* Rec Store theme — small enhancements. Everything works without JS too. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('CartToast');
    if (!el) return;
    el.innerHTML = '';
    el.appendChild(document.createTextNode(message));
    var link = document.createElement('a');
    link.href = root + 'cart';
    link.textContent = 'View bag ›';
    el.appendChild(link);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3500);
  }

  // Add to bag without leaving the page
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-add-to-cart]')) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        toast('Added to your bag.');
        if (button) {
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 1500);
        }
      })
      .catch(function (err) {
        toast((err && err.description) || 'Sorry, that couldn’t be added.');
      })
      .finally(function () { if (button) button.disabled = false; });
  });

  // Filter tabs on the product grid
  document.querySelectorAll('[data-product-grid]').forEach(function (section) {
    var buttons = section.querySelectorAll('[data-filter]');
    var cards = section.querySelectorAll('.card[data-collections]');
    var empty = section.querySelector('[data-grid-empty]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-filter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var shown = 0;
        cards.forEach(function (card) {
          var match = handle === 'all' || (' ' + card.getAttribute('data-collections') + ' ').indexOf(' ' + handle + ' ') > -1;
          card.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  });

  // Mobile menu: close button, Escape key, and click outside the panel
  document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
    var close = function () { drawer.removeAttribute('open'); };
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.open) close(); });
    document.addEventListener('click', function (e) {
      if (!drawer.open) return;
      var panel = drawer.querySelector('.drawer__panel');
      if (panel && !panel.contains(e.target) && !drawer.querySelector('summary').contains(e.target)) close();
    });
    drawer.addEventListener('toggle', function () {
      document.documentElement.style.overflow = drawer.open ? 'hidden' : '';
      if (drawer.open) { var c = drawer.querySelector('[data-drawer-close]'); if (c) c.focus({ preventScroll: true }); }
    });
  });

  // Product page: thumbnails and variant price
  var mainImage = document.getElementById('PdpMainImage');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = thumb.getAttribute('data-thumb');
    });
  });
  var variantSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  }
})();
